export const GET_ALL_RMS = '/rms/';
export const GET_RMS = '/rms/';
export const GET_MY_RMS = '/rms/myrms/';
export const CREATE_RMS = '/rms/';
export const UPDATE_RMS = '/rms/';
export const LINK_RESUME = '/resume/original';
